export default __webpack_public_path__ + "static/media/spinner.2bfad144.svg";